import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMockConfig, modifyMockConfig } from 'domains/appContext/AppContext.store';
import { SectionWrapper } from 'pages/SettingsPage/ProfilePage.styled';
import { Flex, MarginBox, Switch, Text } from 'UI';

const MokDetail = ({ name }: { name: string }) => {
  const dispatch = useDispatch();
  const mockConfig = useSelector(getMockConfig);
  const parameter = `mock${name}`;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const mock: boolean | undefined = !mockConfig ? undefined : mockConfig[parameter];

  const onChange = () => {
    dispatch(
      modifyMockConfig({
        ...mockConfig,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        [parameter]: !mock,
      }),
    );
  };

  if (mock === undefined) return <></>;
  return (
    <>
      <MarginBox mt={10} />
      <Flex justify={'space-between'}>
        <Text type="base">Mock {name}</Text>
        <Switch checked={mock} onChange={onChange} />
      </Flex>
    </>
  );
};

export const MockSettings = () => {
  return (
    <Flex direction={'column'} gap={25} padding={'25px 0'} maxWidth={300}>
      <SectionWrapper>
        <MokDetail name={'AIA'} />
        <MokDetail name={'ARP'} />
        <MokDetail name={'BVE'} />
        <MokDetail name={'DH'} />
        <MokDetail name={'REP'} />
        <MokDetail name={'RP4'} />
        <MokDetail name={'IAM'} />
        <MokDetail name={'DRV'} />
        <MokDetail name={'PNE'} />
        <MokDetail name={'Sidexa'} />
        <MokDetail name={'Opisto'} />
      </SectionWrapper>
    </Flex>
  );
};
